export default __webpack_public_path__ + "static/grill-f85ce5d6fa76bfc63c3b88749dcf4321.jpg";